import { falsyOrUUID } from './falsyOrUUID'

export const isNonEmptyUUID = (uuid?: string | null): uuid is string => uuid !== null && !!falsyOrUUID(uuid)
